import { useCallback} from 'react';
import { UPDATE_JOB_AUDIT_SITE_DATA } from 'src/graphql/mobile/mutation';
import { useMutation } from 'src/graphql';

export default (params = {}) => {
  const [updateJobAuditSiteData, { data, error, ...rest }] = useMutation(UPDATE_JOB_AUDIT_SITE_DATA, {
    ...params,
  });

  return useCallback(async (jobId, payload) => {
    return updateJobAuditSiteData({ variables: { jobId, data: payload } });
  },[]);
};
